// 禁止输入空格的指令
const noSpace = (app) => {
  app.directive("no-space", {
    mounted(el, binding) {
      el.addEventListener("input", function (event) {
        const value = event.target.value;
        if (/\s/.test(value)) {
          event.target.value = value.replace(/\s/g, "");
          event.target.dispatchEvent(new Event("input"));
        }
      });
    },
  });
};

export default noSpace;
